export const elementTypesList = ['checkbox', 'switch'];
